// Code generated by domaingen. DO NOT EDIT.

export enum ActivityCategory {
  Task = 'Task',
  Call = 'Call',
  Email = 'Email',
  SalesVisit = 'Sales Visit',
  SiteVisit = 'Site Visit',
  Other = 'Other',
}
export enum ActivityStatus {
  Planned = 'Planned',
  Completed = 'Completed',
  Canceled = 'Canceled',
}
export enum ActualsAlertSeverity {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}
export enum ActualsAlertType {
  ProjectEndDelay = 'project_end_delay',
  ProjectStartDelay = 'project_start_delay',
  ProjectMissingStartDate = 'project_missing_start_date',
  ProjectMissingEndDate = 'project_missing_end_date',
  ProjectMissingForecast = 'project_missing_forecast',
  ProjectApproachingDeadline = 'project_approaching_deadline',
}
export enum ActualsPerformanceStatus {
  AtRisk = 'At Risk',
  Warning = 'Warning',
  OnTrack = 'On Track',
}
export enum AsyncJobStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}
export enum AsyncJobType {
  QuotePricingUpdate = 'quote_pricing_update',
  QuotePriceEscalation = 'quote_price_escalation',
}
export enum CompanyCategory {
  Contractor = 'Contractor',
  Engineer = 'Engineer',
  Subcontractor = 'Subcontractor',
  Owner = 'Owner',
  Vendor = 'Vendor',
  Supplier = 'Supplier',
  OutsideDesigner = 'Outside Designer',
  Architect = 'Architect',
  GeneralContractor = 'General Contractor',
}
export enum Comparator {
  Lt = 'lt',
  Lte = 'lte',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
}
export enum CostRuleKind {
  Ratio = 'Ratio',
  Flat = 'Flat',
}
export enum CurrencyCode {
  USD = 'USD',
  AUD = 'AUD',
  CAD = 'CAD',
  GBP = 'GBP',
}
export enum CustomFieldDefinitionDomainType {
  Projects = 'projects',
  Plants = 'plants',
}
export enum CustomFieldType {
  String = 'string',
  Number = 'number',
  Date = 'Date',
  Options = 'options',
  Text = 'text',
}
export enum DashboardKind {
  Admin = 'Admin',
  CRM = 'CRM',
  Database = 'Database',
  Reporting = 'Reporting',
}
export enum DispatchActualsImportStatus {
  Ok = 'Ok',
  Pending = 'Pending',
  Error = 'Error',
}
export enum EscalationKind {
  Percentage = 'Percentage',
  Flat = 'Flat',
}
export enum FeatureFlagName {
  TestDummy = '_',
  DataTablePrinting = 'DataTablePrinting',
  FeatureFlagActualsDashboard = 'ActualsDashboard',
  FeatureFlagMultiTruckEnabled = 'MultiTruckEnabled',
  FeatureFlagDispatchCustomer = 'DispatchCustomer',
  FeatureFlagIntegrationImport = 'IntegrationImport',
  FeatureFlagIntegrationExport = 'IntegrationExport',
  FeatureFlagIntegrationRestrictOrders = 'IntegrationRestrictOrders',
  FeatureFlagRequiresCompanyMarkets = 'RequiresCompanyMarkets',
  FeatureFlagRequiresQuoteCompany = 'RequiresQuoteCompany',
  FeatureFlagRequiresQuoteCompanyContact = 'RequiresQuoteCompanyContact',
  FeatureFlagRequiresQuoteTerms = 'RequiresQuoteTerms',
  FeatureFlagRequiresQuoteQuoteConfig = 'RequiresQuoteQuoteConfig',
  FeatureFlagRequiresQuoteExpirationDate = 'RequiresQuoteExpirationDate',
  FeatureFlagRequiresProjectEstimatedStartDate = 'RequiresProjectEstimatedStartDate',
  FeatureFlagRequiresProjectEstimatedEndDate = 'RequiresProjectEstimatedEndDate',
  FeatureFlagRequiresProjectBidDate = 'RequiresProjectBidDate',
  FeatureFlagRequiresProjectExpirationDate = 'RequiresProjectExpirationDate',
  FeatureFlagRequiresProjectAddressCity = 'RequiresProjectAddressCity',
  FeatureFlagRequiresProjectAddress = 'RequiresProjectAddress',
  FeatureFlagRequiresProjectCompany = 'RequiresProjectCompany',
  FeatureFlagRequiresProjectRevenueOverride = 'RequiresProjectRevenueOverride',
  FeatureFlagRequiresProjectReadyMixQuantityOverride = 'RequiresProjectReadyMixQuantityOverride',
  FeatureFlagRequiresProjectSegment = 'RequiresProjectSegment',
  FeatureFlagRequiresProjectConfig = 'RequiresProjectConfig',
  FeatureFlagRequiresContactInfo = 'RequiresContactInfo',
  FeatureFlagRequiresContactEmail = 'RequiresContactEmail',
  FeatureFlagCompetitors = 'Competitors',
  FeatureFlagRequiresProjectTaxCode = 'RequiresProjectTaxCode',
  FeatureFlagMultiLocationEnabled = 'MultiLocationEnabled',
  FeatureFlagRequiresProjectProducts = 'RequiresProjectProducts',
  FeatureFlagBulkQuoteRevisions = 'BulkQuoteRevisions',
  FeatureFlagPriceEscalationAlerts = 'PriceEscalationAlerts',
  FeatureFlagCopilotChat = 'CopilotChat',
  FeatureFlagRequiresProductDeliveryType = 'RequiresProductDeliveryType',
  FeatureFlagAISearch = 'AISearch',
  FeatureFlagGlobalSearch = 'GlobalSearch',
  FeatureFlagQuickActions = 'QuickActions',
  FeatureFlagDefaultPriceToSuggestedPrice = 'DefaultPriceToSuggestedPrice',
  FeatureFlagTierPricing = 'TierPricing',
  FeatureFlagFallbackResolver = 'FallbackResolver',
  FeatureFlagFileAttachments = 'FileAttachments',
  FeatureFlagQuoteEmailAttachments = 'QuoteEmailAttachments',
  FeatureFlagRequiresQuoteProjectJobNumber = 'RequiresQuoteProjectJobNumber',
  FeatureFlagReminderSystemSettings = 'ReminderSystemSettings',
  FeatureFlagRequiresProjectLossDetails = 'RequiresProjectLossDetails',
  FeatureFlagRequiresQuoteLossDetails = 'RequiresQuoteLossDetails',
  FeatureFlagRequiresQuotePriceEscalation = 'RequiresQuotePriceEscalation',
  FeatureFlagExpirationDateShouldBeAfterStartDate = 'ExpirationDateShouldBeAfterStartDate',
  FeatureFlagNotificationCenter = 'NotificationCenter',
  FeatureFlagPlanningRelease = 'PlanningRelease',
  FeatureFlagDiscounts = 'Discounts',
  FeatureFlagPlanning = 'Planning',
}
export enum FilterOperation {
  Equals = 'equals',
  In = 'in',
  Between = 'between',
  StartsWith = 'startswith',
  EndsWith = 'endswith',
  Contains = 'contains',
  NotContains = 'notcontains',
  GreaterOrEquals = 'greaterorequal',
  LessOrEquals = 'lessorequal',
  GreaterThan = 'greater',
  LessThan = 'less',
  EqualsOrNull = 'equalsornull',
  NotEquals = 'notequals',
  NotEqualsAndNotNull = 'notequalsnornull',
  Lookup = 'lookup',
  Search = 'search',
}
export enum ForecastKind {
  Project = 'project',
  Budget = 'budget',
  Capacity = 'capacity',
}
export enum ImportedDiscountStatus {
  Active = 'Active',
  Expired = 'Expired',
  Future = 'Future',
}
export enum IntegrationType {
  Series = 'series',
  Sysdyne = 'sysdyne',
  Integra = 'integra',
  Apex = 'apex',
  Connect = 'connect',
  Bcmi = 'bcmi',
  Keystone = 'keystone',
  Fastweigh = 'fastweigh',
  Aggregatego = 'aggregatego',
}
export enum JobObjectState {
  Pending = 'pending',
  Success = 'success',
  Failure = 'failure',
}
export enum MarginConfiguration {
  Percentage = 'percentage',
  FlatDollar = 'flat_dollar',
}
export enum MaterialType {
  Aggregate = 'Aggregate',
  Cementitious = 'Cementitious',
  Admixture = 'Admixture',
  Fiber = 'Fiber',
  Water = 'Water',
  Other = 'Other',
  Charge = 'Charge',
}
export enum MixCategory {
  ReadyMix = 'ready_mix',
  Asphalt = 'asphalt',
}
export enum NotificationType {
  PushNotification = 'push_notification',
  Email = 'email',
}
export enum NylasProvider {
  Google = 'google',
  Icloud = 'icloud',
  Imap = 'imap',
  Microsoft = 'microsoft',
  Yahoo = 'yahoo',
  Ews = 'ews',
  Custom = 'custom',
  Eas = 'eas',
  Gmail = 'gmail',
}
export enum NylasTokenType {
  Bearer = 'Bearer',
  Digest = 'Digest',
  Basic = 'Basic',
}
export enum PdfTemplateType {
  Code = 'code',
  PdfGenerator = 'pdf_generator',
}
export enum Permission {
  ViewCostData = 'view_cost_data',
  ViewMixDesignsSection = 'view_mix_designs_section',
  ViewMaterialsSection = 'view_materials_section',
  ViewActualsDashboard = 'view_actuals_dashboard',
  ViewTruckingType = 'view_trucking_type',
  CanBulkEditQuotes = 'can_bulk_edit_quotes',
  CanBulkEditProjects = 'can_bulk_edit_projects',
  CanBulkEditCompanies = 'can_bulk_edit_companies',
  CanBulkEditLocations = 'can_bulk_edit_locations',
  CanBulkEditActivities = 'can_bulk_edit_activities',
  CanViewSensitiveFiles = 'can_view_sensitive_files',
  CanViewPlanning = 'can_view_planning',
  CanEditPlanning = 'can_edit_planning',
  CanApprovePlanning = 'can_approve_planning',
  CanEditAllActivities = 'can_edit_all_activities',
}
export enum PlanningNodeKind {
  Customer = 'customer',
  Project = 'project',
  Bucket = 'bucket',
}
export enum PlanningProductClassification {
  Aggregates = 'aggregates',
  OtherIncome = 'other_income',
  Intercompany = 'intercompany',
}
export enum PlantCategory {
  ReadyMix = 'ready_mix',
  Quarry = 'quarry',
}
export enum ProductCategory {
  ReadyMix = 'Ready Mix',
  Resale = 'Resale',
  Precast = 'Precast',
  Other = 'Other',
  Aggregate = 'Aggregate',
  Asphalt = 'Asphalt',
  Charge = 'Charge',
}
export enum ProductDeliveryType {
  Pickup = 'pickup',
  Hauling = 'hauling',
  InternalHauling = 'internal_hauling',
}
export enum ProjectStatusSystemBehavior {
  Custom = 'custom',
  Bidding = 'bidding',
  Won = 'won',
  Pending = 'pending',
  InDevelopment = 'in_development',
  Lost = 'lost',
  Complete = 'complete',
  Archive = 'archive',
}
export enum PushNotificationDeviceType {
  Web = 'web',
  Android = 'android',
  Ios = 'ios',
}
export enum QuoteApprovalLadderMode {
  Inclusive = 'inclusive',
  HighestOnly = 'highest_only',
}
export enum QuoteExportReason {
  Unknown = 'unknown',
  NoCustomer = 'no_customer',
  NoDispatchCustomer = 'no_dispatch_customer',
  ProductWithoutExternalID = 'product_without_external_id',
  MissingProjectAddress = 'missing_project_address',
  InvalidProjectDates = 'invalid_project_dates',
  InvalidContact = 'invalid_contact',
  NotConfigured = 'not_configured',
  Rejected = 'rejected',
  Unavailable = 'unavailable',
}
export enum QuotePolicyThresholdKind {
  MarginMixProductsAverageLessThanDollars = 'margin_mix_products_average_less_than_dollars',
  AlwaysTrigger = 'always_trigger',
  MixProductsUnitPriceBelowListPrice = 'mix_products_unit_price_below_list_price',
  AggregateProductsUnitPriceBelowListPrice = 'aggregate_products_unit_price_below_list_price',
  TotalVolumeBelowValue = 'total_volume_below_value',
  MarginMixProductsLessThanDollars = 'margin_mix_products_less_than_dollars',
  MarginMixProductsGreaterThanDollars = 'margin_mix_products_greater_than_dollars',
  MarginAggregateProductsLessThanDollars = 'margin_aggregate_products_less_than_dollars',
  MarginAggregateProductsGreaterThanDollars = 'margin_aggregate_products_greater_than_dollars',
  MarginAsphaltProductsLessThanDollars = 'margin_asphalt_products_less_than_dollars',
  MarginAsphaltProductsGreaterThanDollars = 'margin_asphalt_products_greater_than_dollars',
  MarginMixProductsAverageLessThanPercent = 'margin_mix_products_average_less_than_percent',
  AsphaltProductsUnitPriceBelowListPrice = 'asphalt_products_unit_price_below_list_price',
  AsphaltProductsUnitPriceAboveListPrice = 'asphalt_products_unit_price_above_list_price',
  MixProductsUnitPriceAboveListPrice = 'mix_products_unit_price_above_list_price',
  AggregateProductsUnitPriceAboveListPrice = 'aggregate_products_unit_price_above_list_price',
  QuantityLineItemMixProductsLessThan = 'quantity_line_item_mix_products_less_than',
  QuantityLineItemMixProductsGreaterThan = 'quantity_line_item_mix_products_greater_than',
  QuantityLineItemAggregateProductsLessThan = 'quantity_line_item_aggregate_products_less_than',
  QuantityLineItemAggregateProductsGreaterThan = 'quantity_line_item_aggregate_products_greater_than',
  QuantityLineItemAsphaltProductsLessThan = 'quantity_line_item_asphalt_products_less_than',
  QuantityLineItemAsphaltProductsGreaterThan = 'quantity_line_item_asphalt_products_greater_than',
  QuantityMixProductsLessThan = 'quantity_mix_products_less_than',
  QuantityMixProductsGreaterThan = 'quantity_mix_products_greater_than',
  QuantityAggregateProductsLessThan = 'quantity_aggregate_products_less_than',
  QuantityAggregateProductsGreaterThan = 'quantity_aggregate_products_greater_than',
  QuantityAsphaltProductsLessThan = 'quantity_asphalt_products_less_than',
  QuantityAsphaltProductsGreaterThan = 'quantity_asphalt_products_greater_than',
  MarginProductsAverageMoreThanPercent = 'margin_products_average_more_than_percent',
  MarginMixProductLineItemPercentLessThan = 'margin_mix_product_line_item_percent_less_than',
  MarginMixProductLineItemPercentGreaterThan = 'margin_mix_product_line_item_percent_greater_than',
  MarginAggregateProductLineItemPercentLessThan = 'margin_aggregate_product_line_item_percent_less_than',
  MarginAggregateProductLineItemPercentGreaterThan = 'margin_aggregate_product_line_item_percent_greater_than',
  MarginAsphaltProductLineItemPercentLessThan = 'margin_asphalt_product_line_item_percent_less_than',
  MarginAsphaltProductLineItemPercentGreaterThan = 'margin_asphalt_product_line_item_percent_greater_than',
  MarginMixProductsAverageGreaterThanDollars = 'margin_mix_products_average_greater_than_dollars',
  MarginAggregateProductsAverageLessThanDollars = 'margin_aggregate_products_average_less_than_dollars',
  MarginAggregateProductsAverageGreaterThanDollars = 'margin_aggregate_products_average_greater_than_dollars',
  MarginAsphaltProductsAverageLessThanDollars = 'margin_asphalt_products_average_less_than_dollars',
  MarginAsphaltProductsAverageGreaterThanDollars = 'margin_asphalt_products_average_greater_than_dollars',
  MarginMixProductsAverageGreaterThanPercent = 'margin_mix_products_average_greater_than_percent',
  MarginAggregateProductsAverageLessThanPercent = 'margin_aggregate_products_average_less_than_percent',
  MarginAggregateProductsAverageGreaterThanPercent = 'margin_aggregate_products_average_greater_than_percent',
  MarginAsphaltProductsAverageLessThanPercent = 'margin_asphalt_products_average_less_than_percent',
  MarginAsphaltProductsAverageGreaterThanPercent = 'margin_asphalt_products_average_greater_than_percent',
}
export enum QuotePolicyThresholdKindShort {
  MarginPercent = 'margin_percent',
  MarginDollars = 'margin_dollars',
  Quantity = 'quantity',
  UnitPriceVsListPrice = 'unit_price_vs_list_price',
  AlwaysTrigger = 'always_trigger',
}
export enum QuotePolicyThresholdProductAggregationKind {
  LineItem = 'line_item',
  Average = 'average',
  Total = 'total',
}
export enum QuotePolicyViolationState {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Archived = 'archived',
}
export enum QuoteProductKind {
  Primary = 'primary',
  Additional = 'additional',
  Charge = 'charge',
}
export enum QuoteStatusSystemBehavior {
  Draft = 'draft',
  ApprovalRequest = 'approval_request',
  ApprovedToSend = 'approved_to_send',
  Sent = 'sent',
  ApproverRejected = 'approver_rejected',
  BuyerRejected = 'buyer_rejected',
  BuyerAccepted = 'buyer_accepted',
  Archived = 'archived',
  Lost = 'lost',
}
export enum ReminderSystemBusinessDate {
  BidDate = 'Bid Date',
  ExpirationDate = 'Expiration Date',
  EstimatedStartDate = 'Estimated Start Date',
  EstimatedEndDate = 'Estimated End Date',
  StartDate = 'Start Date',
  EscalationDate = 'Escalation Date',
}
export enum ReminderSystemRecordType {
  Project = 'Project',
  Quote = 'Quote',
  Activity = 'Activity',
  PriceEscalation = 'Price Escalation',
}
export enum ReminderUserSettingsBusinessDate {
  BidDate = 'Bid Date',
  ExpirationDate = 'Expiration Date',
  EstimatedStartDate = 'Estimated Start Date',
  EstimatedEndDate = 'Estimated End Date',
  StartDate = 'Start Date',
  General = 'General',
}
export enum ReminderUserSettingsRecordType {
  Project = 'Project',
  Quote = 'Quote',
  Activity = 'Activity',
}
export enum RoleName {
  Salesperson = 'Salesperson',
  SlabstackAdministrator = 'Slabstack Administrator',
  ITAdministrator = 'IT Administrator',
  Manager = 'Manager',
  QualityControl = 'Quality Control',
  Purchasing = 'Purchasing',
  CustomRole = 'Custom Role',
}
export enum SortDirection {
  Descending = 'desc',
  Ascending = 'asc',
}
export enum Unit {
  CuYd = 'cu_yd',
  Ea = 'ea',
  Lb = 'lb',
  Tn = 'tn',
  FlOz = 'fl_oz',
  FlOzPerCwt = 'fl_oz_per_cwt',
  Gal = 'gal',
  PerHr = 'per_hr',
  In = 'in',
  Ft = 'ft',
  Yd = 'yd',
  Lf = 'lf',
  Mm = 'mm',
  Cm = 'cm',
  M = 'm',
  Km = 'km',
  SqIn = 'sq_in',
  SqFt = 'sq_ft',
  SqYd = 'sq_yd',
  SqMi = 'sq_mi',
  Ac = 'ac',
  SqMm = 'sq_mm',
  SqCm = 'sq_cm',
  SqM = 'sq_m',
  SqKm = 'sq_km',
  CuIn = 'cu_in',
  CuFt = 'cu_ft',
  CuMm = 'cu_mm',
  CuCm = 'cu_cm',
  CuM = 'cu_m',
  Pt = 'pt',
  Qt = 'qt',
  L = 'L',
  ML = 'mL',
  Oz = 'oz',
  G = 'g',
  Kg = 'kg',
  T = 't',
  PerL = 'per_L',
  PerQty = 'per_qty',
  PerCuYd = 'per_cu_yd',
  PerM = 'per_m',
  Bag = 'bag',
  Dosage = 'dosage',
  Percent = 'percent',
  PerTn = 'per_tn',
  PerLoad = 'per_load',
  Mi = 'mi',
  PerCuM = 'per_cu_m',
  BlockEquivalentUnit = 'block_equivalent_unit',
  PerHalfLoad = 'per_half_load',
  Psi = 'psi',
  Mpa = 'mpa',
}
export enum UserSettingKey {
  UserTourMobile = 'UserTourMobile',
  SwipeEducationMobile = 'SwipeEducationMobile',
}
export enum WsEvent {
  QuoteUpdate = 'ON_QUOTE_UPDATE',
  QuoteEditLockChanged = 'ON_QUOTE_EDIT_LOCK_CHANGED',
  Ping = 'PING',
  Reconnected = 'ON_RECONNECTED',
  NotificationCreated = 'ON_NOTIFICATION_CREATED',
  NotificationsChanged = 'ON_NOTIFICATIONS_CHANGED',
}
